// extracted by mini-css-extract-plugin
export default {"row":"tariff_row__zvLW+","price":"tariff_price__e1nC4","icon":"tariff_icon__SC66Q","word":"tariff_word__qjErU","title":"tariff_title__CkhoC","box_close":"tariff_box_close__DVRCo"};